import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import CheckBox from '../CheckBox';
import Input from '../Input';
import Icon from '../Icon';
import { isFunction } from '@utiljs/is';
var CheckBoxGroup = CheckBox.Group;

var TransferPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(TransferPanel, _React$Component);

  var _super = _createSuper(TransferPanel);

  function TransferPanel() {
    var _this;

    _classCallCheck(this, TransferPanel);

    _this = _super.apply(this, arguments);
    _this.state = {
      filter: '',
      data: undefined
    };

    _this.filterOption = function (event) {
      var filter = event.target.value;
      var _this$props = _this.props,
          filterMethod = _this$props.filterMethod,
          fieldNames = _this$props.fieldNames;
      var data = _this.state.data;
      var filterData = data.filter(function (item) {
        if (isFunction(filterMethod)) {
          return filter ? filterMethod(filter, item) : true;
        }

        return item[fieldNames.label].includes(filter);
      });

      _this.setState({
        filter: filter,
        data: filterData
      });
    };

    _this.handleAllChange = function (event) {
      var fieldNames = _this.props.fieldNames;
      var data = _this.state.data;
      var allKeys = data.map(function (item) {
        return item[fieldNames.key];
      });
      var allValue = event.target.checked ? allKeys : [];

      _this.handleSelectedChange(allValue);
    };

    _this.handleSelectedChange = function (value) {
      var _this$props2 = _this.props,
          direction = _this$props2.direction,
          otherSelectedKeys = _this$props2.otherSelectedKeys,
          onSelectedChange = _this$props2.onSelectedChange;

      if (onSelectedChange) {
        if (direction === 'left') {
          onSelectedChange(value, otherSelectedKeys);
        } else {
          onSelectedChange(otherSelectedKeys, value);
        }
      }
    };

    _this.renderFooter = function () {
      var _this$props3 = _this.props,
          footer = _this$props3.footer,
          direction = _this$props3.direction;
      if (!footer) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-transfer-panel-footer roo-transfer-panel-footer-".concat(direction)
      }, isFunction(footer) ? footer() : footer);
    };

    return _this;
  }

  _createClass(TransferPanel, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          fieldNames = _this$props4.fieldNames,
          selectedKeys = _this$props4.selectedKeys,
          title = _this$props4.title,
          empty = _this$props4.empty,
          render = _this$props4.render,
          filterable = _this$props4.filterable,
          filterPlaceholder = _this$props4.filterPlaceholder,
          className = _this$props4.className;
      var _this$state = this.state,
          filter = _this$state.filter,
          data = _this$state.data;
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-transfer-panel ".concat(className)
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-transfer-panel-title"
      }, /*#__PURE__*/React.createElement(CheckBox, {
        className: "roo-transfer-panel-title-all",
        indeterminate: selectedKeys.length > 0 && data.length !== selectedKeys.length,
        checked: data.length > 1 && data.length === selectedKeys.length,
        onChange: this.handleAllChange,
        readOnly: data.length === 0
      }, title), /*#__PURE__*/React.createElement("span", {
        className: "roo-transfer-panel-title-count"
      }, (selectedKeys.length > 0 ? "".concat(selectedKeys.length, "/") : '') + data.length)), filterable && /*#__PURE__*/React.createElement("div", {
        className: "roo-transfer-panel-filter"
      }, /*#__PURE__*/React.createElement(Input, {
        placeholder: filterPlaceholder,
        suffix: /*#__PURE__*/React.createElement(Icon, {
          name: "search"
        }),
        value: filter,
        onChange: this.filterOption
      })), /*#__PURE__*/React.createElement("div", {
        className: "roo-transfer-panel-empty"
      }, data.length === 0 ? empty : null), /*#__PURE__*/React.createElement("div", {
        className: "roo-transfer-panel-body"
      }, /*#__PURE__*/React.createElement(CheckBoxGroup, {
        className: "roo-transfer-panel-list",
        value: selectedKeys,
        onChange: this.handleSelectedChange
      }, (data || []).map(function (item) {
        return /*#__PURE__*/React.createElement(CheckBox, {
          key: item[fieldNames.key],
          value: item[fieldNames.key]
        }, isFunction(render) ? render(item) : item[fieldNames.label]);
      }))), this.renderFooter());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.data !== undefined) {
        var filter = prevState.filter;
        var filterNextData = filter ? nextProps.data.filter(function (item) {
          return item[nextProps.fieldNames.label].includes(filter);
        }) : nextProps.data;
        return {
          data: filterNextData
        };
      }

      return null;
    }
  }]);

  return TransferPanel;
}(React.Component);

TransferPanel.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf(['left', 'right']),
  fieldNames: PropTypes.object,
  data: PropTypes.array,
  otherSelectedKeys: PropTypes.array,
  selectedKeys: PropTypes.array,
  filterable: PropTypes.bool,
  filterMethod: PropTypes.func,
  empty: PropTypes.node,
  filterPlaceholder: PropTypes.string,
  title: PropTypes.string,
  operations: PropTypes.array,
  footer: PropTypes.any,
  render: PropTypes.func,
  onChange: PropTypes.func,
  onSelectedChange: PropTypes.func
};
TransferPanel.defaultProps = {
  className: '',
  direction: '',
  fieldNames: {},
  data: [],
  otherSelectedKeys: [],
  selectedKeys: [],
  filterable: true,
  filterMethod: undefined,
  empty: '',
  filterPlaceholder: '请输入',
  title: '',
  operations: [],
  footer: '',
  render: undefined,
  onChange: undefined,
  onSelectedChange: undefined
};
export default TransferPanel;